import React from 'react';
import { FaWhatsapp, FaLinkedinIn, FaInstagram, FaHome, FaInfo, FaServicestack, FaPhone, FaEnvelope, FaMapMarkerAlt } from 'react-icons/fa';
import 'bootstrap/dist/css/bootstrap.min.css';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="container">
        <div className="row">
          <div className="col-md-3 footer-col">
            <h4>Get In Touch</h4>
            <p><FaMapMarkerAlt /> Thika, Kenya</p>
            <p><FaPhone /> +254 740297050</p>
            <p><FaEnvelope /><a href="mailto:brianmwithi@gmail.com">brianmwithi@gmail.com</a></p>
          </div>

          <div className="col-md-3 footer-col">
            <h4>Quick Links</h4>
            <ul>
              <li><a href="/"><FaHome /> Home</a></li>
              <li><a href="/about"><FaInfo /> About Us</a></li>
              <li><a href="/services"><FaServicestack /> Services</a></li>
              <li><a href="/contact"><FaEnvelope /> Contact</a></li>
            </ul>
          </div>

          <div className="col-md-3 footer-col">
            <h4>Popular Links</h4>
            <ul>
              <li><a href="/about"><FaInfo /> About Us</a></li>
              <li><a href="/services#1"><FaServicestack /> Full Stack Website Development</a></li>
              <li><a href="/services#2"><FaServicestack /> Static Website Design</a></li>
              <li><a href="/services#3"><FaServicestack /> Online CV Creation</a></li>
              <li><a href="/services#4"><FaServicestack /> Portfolio Development</a></li>
            </ul>
          </div>

          <div className="col-md-3 footer-col">
            <h4>Follow Us</h4>
            <div className="social-icons">
            <a href="https://twitter.com/Brayooo9" target="_blank" rel="noopener noreferrer">
                <img src="./Twitter-logo.jpg" alt="Twitter" />
              </a>
              <a href="https://wa.me/+254740297050" target="_blank" rel="noopener noreferrer">
                <FaWhatsapp />
              </a>
              <a href="https://www.linkedin.com/" target="_blank" rel="noopener noreferrer">
                <FaLinkedinIn />
              </a>
              <a href="https://www.instagram.com/" target="_blank" rel="noopener noreferrer">
                <FaInstagram />
              </a>
            </div>
          </div>
        </div>
        <div className="row footer-bottom">
          <div className="col-12 text-center">
            <p>&copy; 2024 WebCrafter Wizards. All Rights Reserved.</p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
